import { z } from 'zod';

export const IntegrationStatusDtoSchema = z.object({
    type: z.literal('priority'),
    started_at: z.date({ coerce: true }),
    closed_at: z.nullable(z.date({ coerce: true })),
    state: z.union([z.literal('running'), z.literal('completed'), z.literal('failed')]),
});

export const IntegrationDtoSchema = z.object({
    id: z.number(),
    key: z.nullable(z.string()),
    organization_id: z.number(),
    name: z.nullable(z.string()),
    implementation: z.object({
        integration_definition_id: z.number(),
    }),
    is_connected: z.boolean(),
    is_active: z.boolean(),
    is_deleted: z.boolean(),
    is_data_synced: z.boolean(),
    is_historical_syncing: z.boolean(),
    sync_status: z.nullable(z.union([z.string(), IntegrationStatusDtoSchema])),
    created_at: z.date({ coerce: true }),
});

export const IntegrationListResponseSchema = z.object({
    count: z.number(),
    items: z.array(IntegrationDtoSchema),
    num_pages: z.number(),
    page: z.number(),
    page_size: z.number(),
});
